import React from 'react';
import ReactDOM from 'react-dom';
import SnackbarQueue from './SnackbarQueue';

const defaultProps = {};
/**
 * Snackbar
 * */
const Snackbar = {
  queues: {},
  createQueue(props, callback) {
    const root = document.body;
    const containerElement = document.createElement('div');
    // 不在DOM中创建节点
    root.appendChild(containerElement);
    let mounted = false;
    function getQueue(queue) {
      if (mounted) {
        return;
      }
      mounted = true;
      callback &&
        callback({
          queue,
          destroy() {
            ReactDOM.unmountComponentAtNode(containerElement);
            containerElement.parentNode.removeChild(containerElement);
          },
        });
    }
    ReactDOM.render(<SnackbarQueue {...props} ref={getQueue} />, containerElement);
  },
  open(itemProps = defaultProps, position = 'top') {
    if (this.queues[position]) {
      this.queues[position].queue.add(itemProps);
    } else {
      this.createQueue({ position }, queue => {
        Snackbar.queues[position] = queue;
        queue.queue.add(itemProps);
      });
    }
  },
  config(newConfig) {
    Object.assign(defaultProps, newConfig);
  },
  destroy() {
    Object.keys(this.queues).forEach(key => {
      this.queues[key].destroy();
      delete this.queues[key];
    });
  },
};

export default Snackbar;



// WEBPACK FOOTER //
// ./src/snackbar/snackbar.jsx